import types from '@/store/mutations/mutation-types';
import { transport } from '@/dao';
import Storage from '@/lib/storage';
import { queryToJson, getEnvSuffix } from '@/lib/tools';
import { parseBrand, fmtBrandPageKey } from '@/lib/parse-brand';
import SJAI from '@/utils/sjai';
const Cookies = new Storage('cookie');
const ls = new Storage('localStorage');

/*
 * 清除系统下所有的cookie
 */
const clearCookie = function () {
    Cookies.removeItem();
};

/**
 * 检测portalName是否存在
 */
const logoutAction = function (url) {
    let accessToken = queryToJson().accessToken || Cookies.getItem('X-DT-accessToken') || ''; // TOKEN;
    if (!accessToken) {
        // 如果清空了
        clearCookie();
        window.location.href = url;
        return;
    }
    G_transmit('logout', {
        message: false,
    }).finally(() => {
        clearCookie();
        window.location.href = url;
    });
};


const actions = {
    loading({ commit }, value) {
        commit(types.LOADING, value !== undefined ? value : true);
    },

    /**
     * 判断token是否存在，如果不存在就退出
     * @param {*} param0
     * @param {*} payload
     */
    checkIsLogout({ commit, dispatch, state }, payload) {
        let accessToken = queryToJson().accessToken || Cookies.getItem('X-DT-accessToken') || ''; // TOKEN;
        if (!accessToken) {
            // 如果清空了
            if (SJAI.isSJAITenant(state)) {
                SJAI.handleNotLogin();
            } else {
                dispatch('logout', payload);
            }
        }
    },
    removeCookies({ commit, dispatch, state }) {
        // clearCookie();
    },
    /**
     * 退出 + 跳转到登录页
     */
    async logout({ commit, dispatch, state }, payload) {
        if (
            window.location.pathname === '/idx/login' ||
            window.location.href.indexOf('/uc/login') != -1
        ) {
            return;
        }
        let loginUrl = '';
        let privatePageBrand = window.casLoginData?.privatePageData?.privatePageBrand || [];
        let brand = state.brand?.publishBrand?.brand || '';
        if (SJAI.isSJAITenant(state)) {
            // 深教ai
            loginUrl = await SJAI.getLogoutUrl();
        } else if (
            // 有登录前缀，并且不走自己的登录
            process.env.VUE_APP_SSO_Login_URL &&
            (privatePageBrand.length == 0 ||
                (privatePageBrand.length && brand && !privatePageBrand.includes(brand)))
        ) {
            loginUrl =
                process.env.VUE_APP_SSO_Login_URL +
                '?authUrl=' +
                encodeURIComponent(window.location.href);
        } else {
            if (brand === 'gzky') {
                // 贵州私有化部署退出标识
                loginUrl =
                    '/idx/login?loginType=logout&authUrl=' +
                    encodeURIComponent(window.location.href);
            } else {
                loginUrl = '/idx/login?authUrl=' + encodeURIComponent(window.location.href);
            }
        }
        logoutAction(loginUrl);
    },

    /**
     * 退出 + 跳转到首页
     */
    async logoutHome({ commit, dispatch, state }, payload) {
        let loginUrl = SJAI.isSJAITenant(state) ? await SJAI.getLogoutUrl() : '/idx/home';
        logoutAction(loginUrl);
    },
    /**
     * 设置state数据
     * @param {Object}  payload {
     * 	 state属性Key: value
     * }
     */
    meta({ commit, dispatch, state }, payload) {
        commit(types.META, payload);
    },

    /**
     * 消息提示，所有的toast提示都走message，不要单独调用组件的message
     * @param {Object} payload {
     *	 msg: toast的文本内容,
     *   type: 'success' || 'loading' || 'none'   默认为 'none'
     * 	 duration: 3000 默认为3秒
     * }
     */
    message({ commit, dispatch, state }, payload) {
        G_dispatchEvent('toast', payload);
        // commit(types.MESSAGE, payload);
    },

    /**
     * 埋点代理, 所有的埋点采用action的方式，放弃分散引用模式
     * @param {Object} payload {
     *	 name: string name(必须), 事件名
     * 	 data: object 需要追踪的数据
     * }
     */
    proxyTrack({ commit, dispatch, state }, payload) {
        // RecordData.track(payload.name, payload.data);
    },

    /**
     * 登录成功后设置
     * @param {*} param0
     * @param {*} data
     */
    loginSuccess({ state, commit, dispatch }, data) {
        return new Promise((resolve, reject) => {
            let token = data.access_token;
            if (data.keepCookie) {
                Cookies.setItem('X-DT-accessToken', { value: token, params: { expires: 30 } });
                Cookies.setItem('is-keep-cookie', {
                    value: data.keepCookie,
                    params: { expires: 30 },
                });
            } else {
                Cookies.setItem('X-DT-accessToken', { value: token });
                Cookies.setItem('is-keep-cookie', { value: data.keepCookie });
            }
            resolve();
        });
    },
    /**
     * 更新state中的品牌相关信息
     */
    updateBrand({ commit, dispatch, state }, data) {
        let { ver, publishBrand } = data || {};
        ls.setItem('brandVer', ver);
        ls.setItem('publishBrand', publishBrand);
        let moduleList = publishBrand.brandModules || publishBrand.brandModulesV2;
        let pageMap = fmtBrandPageKey(moduleList) || {};
        ls.setItem('pagePermission', pageMap);

        commit(types.META, {
            brand: {
                ver,
                publishBrand,
            },
            brandFactory: parseBrand(publishBrand, state.currentUser),
            pagePermission: pageMap,
        });
    },
    updateMemberInfo({ commit, dispatch, state }, data) {
        commit(types.META, {
            memberUser: data,
        });
    },
    /**
     * 设置站点基本信息
     */
    setSiteInfo({ commit, dispatch, state }, data) {
        let { publishBrand } = data || {};
        let { brandConfig } = publishBrand || {};

        // 设置title
        // document.title = brandConfig.webTitle;

        // 设置favicon
        /** @type {HTMLLinkElement} link */
        let link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = brandConfig.favicon;
        document.getElementsByTagName('head')[0].appendChild(link);

        // 设置网站描述
        if (brandConfig.brandDescription) {
            let head = document.getElementsByTagName('head');
            if (document.querySelector('meta[name="description"]')) {
                document
                    .querySelector('meta[name="description"]')
                    .setAttribute('content', brandConfig.brandDescription);
            } else {
                let metaDescription = document.createElement('meta');
                metaDescription.setAttribute('name', 'description');
                metaDescription.setAttribute('content', brandConfig.brandDescription);
                head[0].appendChild(metaDescription);
            }
        }
    },
    /**
     * 获取微信授权 CODE
     */
    getWechatOauthCode({ dispatch }, callback) {
        // https://ipx.yanxiu.com/train/login?code=&code=abcdefg&state=code&sssscodesssss&statessss&state&projectId=1024&role=100&to=userCenter&code
        let queryIndex = callback.indexOf('?'),
            queryStr = '';
        if (queryIndex > -1) {
            queryStr = callback
                .slice(queryIndex)
                .replace(/[?&](code|state)(=[^&]*|(?=&|$))/g, '')
                .replace(/^&/, '?');
            callback = callback.replace(/\?.*/g, queryStr);
        }

        return G_transmit('getWechatOauthUrl', {
            name: 'getWechatOauthUrl',
            message: false,
            data: {
                url: encodeURIComponent(callback),
            },
        })
            .then(res => res)
            .catch(error => ({ success: false, message: error.message }));
    },
    setBreadCrumb({ commit, dispatch, state }, list) {
        // 设置的面包屑
        commit(types.META, {
            breadCrumbList: list,
        });
    },
    /**
     * 注册离开当前页面或容器提示。如只在离开页面前弹出提示，只用这一个函数就行，不需要再手动执行removeLeave销毁
     * @param {Object} data (*type, title, content)
     *  type: 默认为 page，传其他是为了不相互覆盖
     *  title: 弹窗标题
     *  content: 弹窗内容
     */
    registerLeave({ commit, state }, data) {
        if (data) {
            let saveData = state.leaveBlocks || {};
            const type = data.type || 'page';
            if (type === 'page') {
                saveData = {
                    ...saveData,
                    page: data,
                };
            } else {
                saveData[`${saveData.type}_${new Date().getTime()}`] = data;
            }
            commit(types.LEAVE_BLOCK_UPDATE, saveData);
            return saveData;
        } else {
            throw new TypeError('need params');
        }
    },
    /**
     * 删除离开当前页面或容器提示
     * @param {Object} data (*type)
     *  type: 默认为 page，传其他是为了不相互覆盖
     */
    removeLeave({ commit, state }, data) {
        let saveData = state.leaveBlocks || null;
        if (data) {
            if (saveData && saveData[data.type]) {
                delete saveData[data.type];
            }
        } else {
            saveData = null;
        }
        commit(types.LEAVE_BLOCK_UPDATE, saveData);
    },
    /**
     * 手动判断是否可以离开当前页面或容器，否则弹窗。此函数主要用于离开当前容器或除离开页面外较复杂的回调，注意需手动执行removeLeave销毁
     * @param {Object} data (*type, onOk)
     *  type: 默认为 page，传其他是为了不相互覆盖
     *  onOk: 同 iview onOk
     */
    checkLeave({ dispatch, state }, data) {
        let type = '';
        if (data) {
            type = data.type || 'page';
        }
        if (type && state.leaveBlocks && state.leaveBlocks[type]) {
            dispatch('showLeaveBlockConfirm', Object.assign({}, state.leaveBlocks[type], data));
        } else {
            data.onOk && data.onOk();
        }
    },
};

export default actions;
